(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom_collection_faq"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function () {
    const questions = document.querySelectorAll(".faq-question");

    questions.forEach((btn) => {
      btn.addEventListener("click", function () {
        const currentAnswer = this.nextElementSibling;

        document.querySelectorAll(".faq-answer").forEach((answer) => {
          if (answer !== currentAnswer) {
            answer.classList.remove("open");
            answer.style.maxHeight = null;
          }
        });

        if (currentAnswer.classList.contains("open")) {
          currentAnswer.classList.remove("open");
          currentAnswer.style.maxHeight = null;
        } else {
          currentAnswer.classList.add("open");
          currentAnswer.style.maxHeight = currentAnswer.scrollHeight + "px";
        }
      });

      const index = btn.dataset.index;
      if (index === "0") {
        const answer = btn.nextElementSibling;
        answer.classList.add("open");
        answer.style.maxHeight = answer.scrollHeight + "px";
      }
    });
  });

  } catch(e) { console.error(e); }
})();
})();
